import { createRouter, createWebHistory } from 'vue-router'
import routes from './public/router.map'

// 不需要登录拦截的路由配置
const loginIgnore = {
  names: ['404', '403'], //根据路由名称匹配
  paths: ['/login', '/wx/login', '/loginPrivacy','/jumpToChangliang','/jumpToTonghua','/jumpToLide','/jumpToFundLD'], //根据路由fullPath匹配
  /**
   * 判断路由是否包含在该配置中
   * @param route vue-router 的 route 对象
   * @returns {boolean}
   */
  includes(route) {
    return this.names.includes(route.name) || this.paths.includes(route.path)
  }
}

/**
 * 初始化路由实例
 */
function initRouter() {
  return createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  })
}

export { loginIgnore, initRouter }